export default {
  // Nav
  "brand": "USFansLink",
  "nav.home": "Inicio",
  "nav.categories": "Categorías",
  "nav.guides": "Guías",
  "nav.faq": "Preguntas",
  "nav.cta": "Ver la hoja",
  "nav.shoppingGuide": "Guía de compra",

  // Hero
  "hero.badge": "Actualizado para 2026",
  "hero.title": "USFans Spreadsheet — hallazgos, QC, W2C y guías de compra",
  "hero.subtitle": "Un solo lugar organizado para explorar productos, categorías, información de QC, enlaces W2C, guías de envío y consejos de compra honestos antes de pedir.",
  "hero.search": "Busca categorías, QC, W2C, envío o reseñas...",
  "hero.cta1": "USFans Spreadsheet",
  "hero.cta2": "Comprar ahora",

  // Trust
  "trust.1": "Recursos actualizados",
  "trust.2": "Información independiente",
  "trust.3": "Guías para principiantes",

  // Categories
  "categories.badge": "Categorías de productos",
  "categories.title": "Explora las categorías de productos",
  "categories.subtitle": "Ve directo a la categoría que necesitas en el sitio principal.",
  "categories.dropdownLabel": "Elige una categoría",
  "categories.dropdownPlaceholder": "Selecciona una categoría para explorar",
  "categories.empty": "No hay categorías que coincidan con tu búsqueda.",
  "categories.visit": "Ver categoría",

  // Category names
  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas / Suéteres",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones / Shorts",
  "cat.headwear": "Gorros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior / Calzoncillos",
  "cat.jersey": "Camiseta deportiva",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",

  // What Is
  "whatis.title": "¿Qué es el USFans Spreadsheet?",
  "whatis.p1": "El USFans Spreadsheet es un recurso organizado para descubrir productos, enlaces de producto, información de QC y recursos de compra. En lugar de buscar enlaces dispersos, una hoja bien estructurada facilita explorar productos, categorías y guías útiles en un solo lugar.",
  "whatis.p2": "Ya sea que busques zapatos, sudaderas, camisetas deportivas o accesorios, la hoja te ayuda a pasar de una idea de producto a un enlace verificado y a una lista clara de qué revisar antes de hacer el pedido.",
  "whatis.cta": "Explorar la hoja",

  // Features
  "features.title": "Todo lo que necesitas antes de comprar",
  "features.subtitle": "Recursos prácticos que te ayudan a investigar, comparar y pedir con más confianza.",
  "feature.1.title": "USFans Spreadsheet",
  "feature.1.desc": "Explora recursos de productos organizados y enlaces de categorías en un solo lugar.",
  "feature.2.title": "Guía de QC",
  "feature.2.desc": "Aprende qué revisar y cómo leer las fotos de control de calidad antes de pedir.",
  "feature.3.title": "Enlaces W2C",
  "feature.3.desc": "Entiende los enlaces de producto y los recursos W2C para encontrar lo que buscas.",
  "feature.4.title": "Costo de envío",
  "feature.4.desc": "Aprende qué afecta el costo final de envío y cómo planear tu presupuesto.",
  "feature.5.title": "Reseña de USFans",
  "feature.5.desc": "Entiende el servicio, su flujo de trabajo y sus limitaciones antes de usarlo.",
  "feature.6.title": "Seguridad en USFans",
  "feature.6.desc": "Aprende a reducir los riesgos online comunes y a comprar con más cuidado.",

  // Article CTA
  "articleCta.title": "Lee la guía completa",
  "articleCta.subtitle": "¿Nuevo en el USFans Spreadsheet? Empieza con nuestra guía para principiantes y entiende cómo funciona todo.",
  "articleCta.button": "Leer la guía del USFans Spreadsheet",
  "articleCta.note": "Guías • Reseñas • Consejos de seguridad",

  // FAQ
  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas a las preguntas más comunes sobre el USFans Spreadsheet.",
  "faq.1.q": "¿Qué es el USFans Spreadsheet?",
  "faq.1.a": "Es una colección organizada de enlaces de producto, categorías, información de QC y recursos de compra que te ayuda a descubrir e investigar productos antes de pedir.",
  "faq.2.q": "¿Cómo funciona USFans?",
  "faq.2.a": "USFans funciona como un servicio de compra y reenvío. Encuentras un enlace de producto, lo haces a través del servicio y este ayuda con la compra, el QC y el envío a tu dirección.",
  "faq.3.q": "¿USFans es legítimo?",
  "faq.3.a": "USFans es un servicio de compra muy comentado, pero siempre debes investigar por tu cuenta, leer comentarios recientes de la comunidad y verificar los datos del vendedor y del pago antes de pedir.",
  "faq.4.q": "¿USFans es seguro?",
  "faq.4.a": "Ninguna compra online está totalmente libre de riesgo. Reduce el riesgo revisando las reseñas del vendedor, confirmando las fotos de QC y usando métodos de pago seguros.",
  "faq.5.q": "¿Cuánto cuesta el envío de USFans?",
  "faq.5.a": "El costo de envío depende del peso, las dimensiones, el destino y el método de envío que elijas. La consolidación puede ayudarte a reducir el costo total.",
  "faq.6.q": "¿Qué es un almacén de USFans?",
  "faq.6.a": "El almacén guarda tus artículos después de la compra, donde se toman las fotos de QC y se consolidan los paquetes antes del envío internacional.",
  "faq.7.q": "¿Dónde encuentro los enlaces W2C de USFans?",
  "faq.7.a": "Los enlaces W2C suelen compartirse en la hoja o en recursos de la comunidad. Verifica siempre un enlace antes de usarlo.",
  "faq.8.q": "¿Hay cupones de USFans disponibles?",
  "faq.8.a": "Las promociones y descuentos pueden cambiar con frecuencia. Revisa el sitio principal para ver las ofertas actuales y verifica cualquier cupón antes de usarlo.",

  // Guides section
  "guides.badge": "Guías y artículos",
  "guides.title": "Guías y artículos de USFans",
  "guides.subtitle": "Guías originales y detalladas sobre reseñas, envíos, QC, W2C, seguridad y más.",
  "guides.readMore": "Leer artículo",

  // Final CTA
  "final.title": "¿Listo para explorar el USFans Spreadsheet?",
  "final.subtitle": "Explora categorías de productos, encuentra recursos de QC y W2C y pide con un plan más claro.",
  "final.button": "Explorar el USFans Spreadsheet",

  // Footer
  "footer.tagline": "Tu centro de recursos independiente para el USFans Spreadsheet — hallazgos, QC, W2C, envío y guías de compra.",
  "footer.disclaimer": "USFansLink es un recurso informativo independiente. Salvo que se indique lo contrario, no está afiliado, respaldado ni operado por USFans.",
  "footer.explore": "Explorar",
  "footer.resources": "Recursos",
  "footer.legal": "Legal",
  "footer.home": "Inicio",
  "footer.categories": "Categorías",
  "footer.guide": "Guía del USFans Spreadsheet",
  "footer.faq": "Preguntas frecuentes",
  "footer.mainSite": "Sitio principal",
  "footer.privacy": "Política de privacidad",
  "footer.terms": "Términos de uso",
  "footer.disclaimerTitle": "Aviso legal",
  "footer.rights": "Todos los derechos reservados.",
};